export interface SubActivity {
  id?: number;
  activityId: number;
  title: string;
}
